var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrmelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 262.4",
    style: {
      enableBackground: "new 0 0 1000 262.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000080;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.2,243.2c-19.7-11-35.2-26.3-46.7-45.8C9,177.8,3.2,155.7,3.2,131c0-24.4,5.8-46.4,17.3-66 C32,45.5,47.6,30.3,67.2,19.2c19.6-11,41.2-16.5,64.7-16.5c23.7,0,45.4,5.5,64.9,16.5c19.5,11,35,26.3,46.4,45.8 c11.4,19.5,17.1,41.5,17.1,66c0,24.7-5.7,46.8-17.1,66.3c-11.4,19.5-26.9,34.8-46.5,45.8c-19.7,11-41.2,16.5-64.7,16.5 S86.9,254.2,67.2,243.2z M171.8,204.5c11.5-6.8,20.5-16.6,27-29.3c6.5-12.7,9.7-27.4,9.7-44.2c0-16.8-3.2-31.5-9.7-44 c-6.5-12.6-15.5-22.2-27-28.9C160.3,51.4,147,48,131.9,48c-15.1,0-28.5,3.4-40.1,10.1C80.2,64.8,71.2,74.4,64.7,87 c-6.5,12.6-9.7,27.3-9.7,44c0,16.8,3.2,31.5,9.7,44.2c6.5,12.7,15.5,22.5,27.1,29.3c11.6,6.8,25,10.2,40.1,10.2 C147,214.8,160.3,211.4,171.8,204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427,257.2l-55.4-97.8H348v97.8h-50.3V6.3h94.2c19.4,0,35.9,3.4,49.6,10.2c13.7,6.8,23.9,16.1,30.7,27.7 c6.8,11.6,10.2,24.6,10.2,39c0,16.5-4.8,31.5-14.4,44.8c-9.6,13.3-23.8,22.5-42.8,27.5l60,101.7H427z M348,121.7H390 c13.7,0,23.8-3.3,30.6-9.9c6.7-6.6,10.1-15.8,10.1-27.5c0-11.5-3.4-20.4-10.1-26.8c-6.7-6.3-16.9-9.5-30.6-9.5H348V121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M801.6,6.3v250.9h-50.3V94L684,257.2h-38.1L578.4,94v163.2H528V6.3h57.2L665,192.8L744.8,6.3H801.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M901.5,46.9v62.9H986v39.9h-84.5v66.5h95.3v41H851.2V5.9h145.6v41H901.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrmelogo);
export default __webpack_public_path__ + "static/media/ormelogo.2561dc6693b4844bf28e3ab8ba1bef0a.svg";
export { ForwardRef as ReactComponent };